var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-primary is-loading",attrs:{"type":"submit"},on:{"click":_vm.viewPDF}},[(_vm.isLoading)?_c('i',{staticClass:"fas fa-spinner fa-pulse"}):_vm._e(),_vm._v(" PDF ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }